<mat-card>
  <gymfinder-alert variant="info" class="alert-margin-top">
    <span
      >You can upload images in JPG and PNG formats, and they should be in
      landscape orientation.<br />If you have larger images to upload, please
      limit the number of images you upload at the same time.<br />
      Adding / deleting images takes immediate effect.
    </span>
  </gymfinder-alert>
  @if (gym.gymImages.length) {
    <div class="image-list existing-images-list">
      @for (image of gym.gymImages; track image; let i = $index) {
        <gymfinder-gym-image-preview
          class="image-list-item"
      [ngClass]="{
        'main-picture-border': i === 0,
      }"
          [src]="image.imageURL"
          [isMainPicture]="gym.mainImageId === image.imageId"
          (selectMainPicture)="!updatingImages && selectMainPicture(image.imageId)"
          (deleteImage)="!updatingImages && deleteExistingImage(image.imageId)">
        </gymfinder-gym-image-preview>
      }
    </div>
  }
  <div
    class="drag-zone"
    gymfinderDropZone
    (click)="!updatingImages && fileUpload.click()"
    (fileDropped)="!updatingImages && onFileDropped($event)">
    <input
      multiple="true"
      type="file"
      class="upload-input"
      (change)="onFileSelected($event)"
      [accept]="allowedImageTypes.join(',')"
      #fileUpload />

    <p>Drop some pictures to upload, or click to select some</p>
  </div>
</mat-card>
